<template>
  <div class="recipe">

    <div class="container-fluid" style="padding: 0;">
      <div class="row no-gutters">
        <div class="cell col-12" :class="splitClass('col-SPLIT-6')">
          <strong>Rakennuksen osa</strong>
        </div>
        <div class="d-none" :class="[splitClass('col-SPLIT-6'), splitClass('d-SPLIT-block')]">
          <div class="container-fluid" style="padding: 0;">
            <div class="row no-gutters">
              <div class="cell col-1">

              </div>
              <div class="cell col-3 text-right">
                <strong>Määrä</strong>
              </div>
              <div class="cell col-2">
                <strong>Yks</strong>
              </div>
              <div class="cell col-3 text-right">

              </div>
              <div class="cell col-3 text-right">
                <strong>Kust.eur</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters recipe-row" style="border-top: 2px solid black;" @click="onEditRecipe(recipe)">
        <div class="cell col-12" :class="splitClass('col-SPLIT-6')">
          <i class="fas fa-caret-right"></i> {{ recipe.name }}
        </div>
        <div class="d-none" :class="[splitClass('col-SPLIT-6'), splitClass('d-SPLIT-block')]">
          <div class="container-fluid" style="padding: 0;">
            <div class="row no-gutters">
              <div class="cell col-1">

              </div>
              <div class="cell col-3 text-right">
                {{ recipe.amount | formatNumber }}
              </div>
              <div class="cell col-2">
                {{ recipe.amountUnit.toLowerCase() }}
              </div>
              <div class="cell col-3 text-right">

              </div>
              <div class="cell col-3 text-right">
                {{ recipe.totalCost | formatNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />

    <p v-html="description"></p>

    <div class="container-fluid" style="padding: 0;" v-if="!compact">
      <div class="row no-gutters">
        <div class="cell col-12"  :class="splitClass('col-SPLIT-6')" style="border-bottom: 2px solid black;">
          <strong>Tuote</strong>
        </div>
        <div class="col-12" :class="splitClass('col-SPLIT-6')" style="border-bottom: 2px solid black;">
          <div class="container-fluid" style="padding: 0;">
            <div class="row no-gutters">
              <div class="cell col-1">
                <strong>KL</strong>
              </div>
              <div class="cell col-3 text-right">
                <strong>Määrä</strong>
              </div>
              <div class="cell col-2">
                <strong>Yks</strong>
              </div>
              <div class="cell col-3 text-right">
                <strong>Eur/yks</strong>
              </div>
              <div class="cell col-3 text-right">
                <strong>Kust.eur</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters cost-row" v-for="row in recipe.rows" :key="row.id" @click="onEditRow(recipe, row)">
        <div class="cell col-12"  :class="splitClass('col-SPLIT-6')">
          <i class="fas fa-caret-right"></i> {{ row.name }}
        </div>
        <div class="col-12" :class="splitClass('col-SPLIT-6')">
          <div class="container-fluid" style="padding: 0;">
            <div class="row no-gutters">
              <div class="cell col-1">
                {{ costCategoryNum(row.costCategory) }}
              </div>
              <div class="cell col-3 text-right">
                {{ row.consumption | formatNumber }}
              </div>
              <div class="cell col-2">
                {{ row.consumptionUnit.toLowerCase() }}
              </div>
              <div class="cell col-3 text-right">
                {{ row.costPerConsumptionUnit | formatNumber }}
              </div>
              <div class="cell col-3 text-right">
                {{ row.totalCost | formatNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="cell col-12" :class="splitClass('col-SPLIT-6')">&nbsp;</div>
        <div class="col-12" :class="splitClass('col-SPLIT-6')" style="border-top: 2px solid black;">
          <div class="container-fluid" style="padding: 0;">
            <div class="row no-gutters">
              <div class="cell col">&nbsp;</div>
              <div class="cell col">&nbsp;</div>
              <div class="cell col">&nbsp;</div>
              <div class="cell col">&nbsp;</div>
              <div class="cell col text-right">
                {{ recipe.totalCost | formatNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      recipe: null,
      compact: false
    },
    data() {
      return {
//        split: 'sm'
        split: 'md'
      }
    },

    computed: {
      description() {
        return (this.recipe.description || '').replace(/(?:\r\n|\r|\n)/g, '<br />');
      }
    },

    methods: {
      onEditRecipe(recipe) {
        // alert('Muokkaa: ' + recipe.name);
      },

      onEditRow(recipe, row) {
        // alert('Muokkaa: ' + recipe.name + ' > ' + row.name);
      },

      costCategoryNum(costCategory) {
        switch(costCategory) {
          case 'WORK':
            return 1;
          case 'MATERIAL':
            return 2;
          case 'SUBCONTRACTING':
            return 3;
          case 'EQUIPMENT':
            return 4;
          case 'OTHER':
            return 5;
          default:
            return 0;
        }
      },
      splitClass(clazz) {
        return clazz.replace('SPLIT', this.split)
      }
    }
  }
</script>


<style scoped>
  .recipe {
    /*background-color: #eee;*/
  }
  .cell {
    padding: 3px !important;
  }


  .cost-row,
  .recipe-row {
    cursor: pointer;
  }

  .cost-row:hover,
  .recipe-row:hover {
    background-color: #eee;
  }

  .cost-row:hover .fa-edit,
  .recipe-row:hover .fa-edit {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResultPageRecipe.vue